import React, {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import {requestCashReceipt, getMemberSettlementDetail} from "../../api/transaction/settlementApi";
import {SettlementDetailTypes} from "../../types/settlement/settlement.types";
import {formatDateTime, setComma} from "../../utils/format";
import {formatTimeText} from "../../utils/date";
import {defaultAlert} from "../../utils/alert";

export default function SettlementDetailPage() {

    const {id} = useParams<{ id: string }>();

    const [settlementData, setSettlementData] = useState<SettlementDetailTypes>();
    const [loading, setLoading] = useState(true);
    const [isCashReceipt,  setIsCashReceipt] = useState<boolean>(true);

    const getSettlementDetail = async () => {
        if (!id) return;
        try {
            setLoading(true);
            const result = await getMemberSettlementDetail(id);
            if (result.data.code === "00") {
                setSettlementData(result.data.data);
                setIsCashReceipt(result.data.data.isCashReceipt)
            }
        } catch (err) {
            console.error('정산 상세 에러:', err);
        } finally {
            setLoading(false);
        }
    };

    const cashReceiptBtn = async () => {
        try {
            if (!id) return;
            setIsCashReceipt(false);
            await requestCashReceipt(id);
            defaultAlert('신청되었습니다.');
        } catch (error) {
            setIsCashReceipt(true);
            console.error('Failed to save:', error);
            defaultAlert('신청에 실패했습니다.');
        }
    };


    useEffect(() => {
        getSettlementDetail();
    }, [])

    return (
        <>
            {(!loading && settlementData) && (() => {

                const isServiceFee = settlementData.transactionName === "SERVICE_FEE";
                // 정산 차감(재정산 MINUS) 또는 정산 취소는 마이너스로 표기
                const isMinus = settlementData.pendingSign === "MINUS" || settlementData.settlementStatus === "CANCELLED";

                const serviceName = isServiceFee ? "서비스이용료" : "서비스위약금";
                const workType = settlementData.workType === "DAILY" ? "일급" : "시급";
                const workTypeText = settlementData.workType === "HOURLY" ? "시간제(" + formatTimeText(settlementData.workStartTime) + "~" + formatTimeText(settlementData.workEndTime)+")": "일급제";


                return (
                    <>
                    {isCashReceipt && (
                        <div className="bottom-btn">
                            <button id="cashReceiptBtn" type="button" className="btn confirm" onClick={cashReceiptBtn}>현금영수증 신청</button>
                        </div>
                    )}
                        <main className="container type_gray no-bottom-nav">
                        <section className="bg-white">
                            <div className="inner-box">
                                <h3 className="dot-tit">기본 정보</h3>
                                <ul className="detail-info">
                                    <li>
                                        <span className="tit">정산 금액</span>
                                        <span className="txt" style={isMinus ? {color: '#e47272'} : undefined}>{isMinus ? '-' : ''}{setComma(settlementData.settlementAmount)}원</span>
                                    </li>
                                    {
                                        settlementData.settlementStatus === "CANCELLED" ? (
                                            <li>
                                                <span className="tit">정산취소일시</span>
                                                <span className="txt">{formatDateTime(settlementData.cancelDate)}</span>
                                            </li>
                                        ) : settlementData.settlementStatus === "COMPLETED"  ? (
                                            <li>
                                                <span className="tit">거래일시</span>
                                                <span className="txt">{formatDateTime(settlementData.settlementDate)}</span>
                                            </li>
                                        ) : (
                                        <li>
                                        <span className="tit">거래일시</span>
                                        <span className="txt">{formatDateTime(settlementData.useDate)}</span>
                            </li>
                            )
                                    }
                                    <li>
                                        <span className="tit">정산 구분</span>
                                        <span className="txt">{serviceName}</span>
                                    </li>
                                    <li>
                                        <span className="tit">서비스 구분</span>
                                        <span className="txt">{settlementData.serviceType}</span>
                                    </li>
                                    <li>
                                        <span className="tit">정산번호</span>
                                        <span className="txt">{settlementData.settlementCode}</span>
                                    </li>
                                    <li>
                                        <span className="tit">정산상태</span>
                                        <span className="txt">
                                            <span className={
                                                settlementData.settlementStatus === "COMPLETED"
                                                    ? "status finish"
                                                    : settlementData.settlementStatus === "CANCELLED"
                                                        ? "status cancel"
                                                        : "status"
                                            }>{settlementData.settlementStatusDescription}</span>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </section>
                        <section className="bg-white">
                            <div className="inner-box">
                                <h3 className="dot-tit">공고 정보</h3>
                                <ul className="detail-info">
                                    <li>
                                        <span className="tit">공고번호</span>
                                        <span className="txt">{settlementData.jobPostingCode}</span>
                                    </li>
                                    <li>
                                        <span className="tit">어르신명</span>
                                        <span className="txt">{settlementData.elderName}</span>
                                    </li>
                                    <li>
                                        <span className="tit">시작일</span>
                                        <span className="txt">{settlementData.careStartDate}</span>
                                    </li>
                                    <li>
                                        <span className="tit">종료일</span>
                                        <span className="txt">{settlementData.careEndDate}</span>
                                    </li>
                                    <li>
                                        <span className="tit">서비스 유형</span>
                                        <span className="txt">{workTypeText}</span>
                                    </li>
                                    <li>
                                        <span className="tit">돌봄 급여</span>
                                        <span className="txt">{workType} {setComma(settlementData.dailyPay)}원</span>
                                    </li>
                                    <li>
                                        <span className="tit">총 급여</span>
                                        <span className="txt">{setComma(settlementData.paymentAmount)}원</span>
                                    </li>
                                    <li>
                                        <span className="tit">공고 상태</span>
                                        <span className="txt">{settlementData.jobPostingStatus}</span>
                                    </li>
                                    {settlementData.settlementStatus === "CANCELLED" && (
                                        <li>
                                            <span className="tit">취소자</span>
                                            <span className="txt">{settlementData.cancelSubject}</span>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </section>

                        {!isServiceFee && (
                            <section className="bg-white">
                                <div className="inner-box">
                                    <h3 className="dot-tit">위약금 정보</h3>
                                    <ul className="detail-info">
                                        <li><span className="tit">예약취소일시</span><span
                                            className="txt">{formatDateTime(settlementData.settlementDate)}</span></li>
                                        <li><span className="tit">취소 위약금</span><span className="txt">{setComma(settlementData.settlementAmount)}원</span></li>
                                    </ul>
                                </div>
                            </section>
                        )}

                    </main>
                    </>
                )
            }) ()}
        </>
    )
};